/**
 * This is a typesafe helper function to extract enum values from an enum
 *
 * @param enumObject The enum object to extract the values from
 * @returns The enum values as an array
 */
export function getEnumValues<E extends Record<string, any>>(enumObject: E) {
  return Object.keys(enumObject).map((key) => enumObject[key as keyof E])
}
